export class StepProgressView {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "percentX100",
            "baseName": "percentX100",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "etaSeconds",
            "baseName": "etaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "progressAt",
            "baseName": "progressAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return StepProgressView.attributeTypeMap;
    }
    constructor() {
    }
}
